import React, { useCallback, useState } from 'react';
import { ActivityIndicator, Linking, Platform } from 'react-native';
import { ListItem, Text } from '@rneui/themed';
import { useChannelQuery, getManagePurchasesData } from '@annunciate/query';
import { useUserUUID } from '@annunciate/core';
import { Modal, View } from '../elements';
import { useIsAbleToPurchaseOnStorefront } from '../../hooks';
export const ManagePurchases = () => {
    const { data: channel } = useChannelQuery();
    const uuid = useUserUUID();
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const manage = channel && channel?.channel?.settings?.account?.managePurchases;
    const { isAble: isAbleToPurchase, isLoading: isLoadingAbility } = useIsAbleToPurchaseOnStorefront();
    const onManagePurchases = useCallback(async (wndw = null) => {
        if (isLoadingAbility && Platform.OS !== 'web') {
            return;
        }
        setIsLoading(true);
        let url = undefined;
        let channel = undefined;
        try {
            const data = await getManagePurchasesData();
            url = data.url;
            channel = data.channel;
        }
        catch (err) {
        }
        const linkToOpen = url || manage.link;
        if (!isAbleToPurchase) {
            setIsModalOpen(true);
        }
        else if (wndw) {
            wndw.window.document.location.href = linkToOpen;
        }
        else {
            Linking.openURL(linkToOpen);
        }
        setIsLoading(false);
    }, [manage?.link, isLoadingAbility, isAbleToPurchase]);
    if (!manage || (!uuid && manage.isAuthRequired)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { onPress: () => {
                let wndw = null;
                if (Platform.OS === 'web') {
                    wndw = window.open('', '_blank');
                }
                onManagePurchases(wndw);
            } },
            React.createElement(ListItem.Content, null,
                React.createElement(ListItem.Subtitle, null, manage.name)),
            !isLoading && !isLoadingAbility ? (React.createElement(ListItem.Chevron, { size: 30 })) : (React.createElement(ActivityIndicator, null))),
        React.createElement(Modal, { isVisible: isModalOpen, onCloseModal: () => setIsModalOpen(!isModalOpen), onBackButtonPress: () => setIsModalOpen(!isModalOpen), onBackdropPress: () => setIsModalOpen(!isModalOpen), scrollable: false, style: { maxWidth: 500, margin: 'auto' } },
            React.createElement(View, { style: { marginBottom: 20, marginTop: 20, alignItems: 'center' } },
                React.createElement(Text, { h2: true, bold: true, style: { marginBottom: 10 } }, "We're Sorry For the Hassle"),
                React.createElement(Text, { style: { textAlign: 'center' } }, "To provide the best customer experience, we require all purchase management to be done through our website. Please visit our website via a web browser to do so.")))));
};
//# sourceMappingURL=ManagePurchases.js.map